export default __webpack_public_path__ + "static/Other-Asphalt-Concrete-Removal-32e881cfe9b26ad2d61cbf9d8d20cb64.jpg";